var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_3229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6693 28.779H30.972L30.392 27.9017C30.7467 27.9017 30.9347 27.6764 30.9373 27.4004C30.9373 27.3897 30.9373 27.3777 30.936 27.367C30.936 26.991 30.7093 26.811 30.244 26.811H29.492V28.779H29.7747V27.9217H30.1227L30.6693 28.779ZM30.1027 27.699H29.7747V27.0337H30.1907C30.4053 27.0337 30.6507 27.0684 30.6507 27.3497C30.6507 27.6724 30.404 27.699 30.1027 27.699Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0547 25.4308H19.0453V19.1522C19.0453 17.6548 19.0187 15.7282 16.96 15.7282C14.872 15.7282 14.552 17.3588 14.552 19.0442V25.4308H10.544V12.5188H14.3933V14.2828H14.4467C15.232 12.9415 16.6907 12.1402 18.244 12.1975C22.308 12.1975 23.056 14.8708 23.056 18.3468L23.0547 25.4308ZM6.02 10.7535C4.73467 10.7535 3.69333 9.71216 3.69333 8.42683C3.69333 7.14149 4.73467 6.10016 6.02 6.10016C7.30533 6.10016 8.34667 7.14149 8.34667 8.42683C8.34667 9.71216 7.30533 10.7535 6.02 10.7535ZM8.024 25.4308H4.01067V12.5188H8.024V25.4308ZM25.0533 2.37749H1.996C0.906667 2.36549 0.0133333 3.23883 0 4.32816V27.4802C0.0133333 28.5708 0.906667 29.4442 1.996 29.4322H25.0533C26.1453 29.4455 27.0427 28.5722 27.0573 27.4802V4.32683C27.0413 3.23483 26.144 2.36149 25.0533 2.37616",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1373 25.9351C29.1187 25.9444 28.3 26.7791 28.3106 27.7977C28.32 28.8164 29.1546 29.6351 30.1733 29.6244C31.192 29.6151 32.0106 28.7804 32 27.7617C31.9906 26.7564 31.1773 25.9444 30.1733 25.9351H30.1373ZM30.18 29.4124C29.2867 29.4271 28.508 28.7164 28.4933 27.8231C28.4787 26.9297 29.1906 26.1937 30.084 26.1791C30.9773 26.1644 31.7133 26.8764 31.728 27.7697C31.728 27.7791 31.728 27.7871 31.728 27.7964C31.7466 28.6697 31.0533 29.3937 30.18 29.4124H30.1387H30.18Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_3229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4c96dbc0c344d38ac8c8ca2936144724.svg";
export { ForwardRef as ReactComponent };